import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'kz-div-placeholder',
  template: ``,
  styleUrls: ['./div-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DivPlaceholderComponent {

  @Input()
  @HostBinding('class.logo') logo = false;

  @Input()
  @HostBinding('class.profile') profile = false;

  @HostBinding('class.bg') get bg() {
    return this.logo || this.profile;
  };

  constructor() { }

}
